import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation";

const splashScreen = {
  enabled: true,
  animation: splashAnimation,
  duration: 2000
};

const illustration = {
  animated: true
};

const greeting = {
  username: "Samuel",
  title: "Hi all, I'm Sam",
  subTitle: emoji(
    "Software Engineer with 5+ years of hands-on experience building mobile and web products 🚀, including 3.5 years at AmaliTech shipping Flutter apps to the App Store and Google Play for enterprise clients such as Deutsche Telekom. I work across Flutter, React Native, Kotlin, TypeScript, React / Next.js and Node.js, plus applied machine learning for real-time and on-device inference."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1I1jYq457QAxfxwFXbT9C_UNznoMHeOgT/view?usp=sharing",
  displayGreeting: true
};

const socialMediaLinks = {
  github: "https://github.com/911samuel",
  linkedin: "https://www.linkedin.com/in/abayizera-samuel-184845345/",
  gmail: "samuelabayizera@gmail.com",
  twitter: "https://x.com/AbayizeraSam",
  instagram: "https://www.instagram.com/abayizera7/",
  display: true
};

const skillsSection = {
  title: "What I do",
  subTitle: "MOBILE & FULL STACK ENGINEER WHO OWNS FEATURES END TO END",
  skills: [
    emoji(
      "⚡ Build cross-platform mobile apps with Flutter and React Native, and native Android with Kotlin & Jetpack Compose, from Figma designs to App Store and Google Play releases"
    ),
    emoji(
      "⚡ Design clean, layered architectures (BLoC/Cubit, Riverpod, Redux Toolkit, MVVM) with GraphQL/REST data layers, offline-first caching and push notifications"
    ),
    emoji(
      "⚡ Build web apps and APIs with React, Next.js, TypeScript, Node.js, Express and Flask on PostgreSQL, MongoDB, Firebase and Supabase"
    ),
    emoji(
      "⚡ Ship applied ML (TensorFlow, ONNX, LiteRT, MediaPipe) and keep quality high with unit/widget/integration tests, GitHub Actions CI/CD and Docker"
    )
  ],

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "git",
      fontAwesomeClassname: "fab fa-git-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "github",
      fontAwesomeClassname: "fab fa-github"
    },
    {
      skillName: "figma",
      fontAwesomeClassname: "fab fa-figma"
    }
  ],
  display: true
};

const educationInfo = {
  display: true,
  schools: [
    {
      schoolName: "University of Rwanda",
      logo: require("./assets/images/university_of_rwanda.png"),
      subHeader: "Bachelor of Science in Computer and Software Engineering",
      duration: "2022 - 2026",
      desc: "Final-year project: SignLearn, a real-time sign language translator.",
      descBullets: [
        "Built the ML pipeline, Flask/Socket.IO backend and Next.js frontend end to end",
        "Raised model accuracy from 73% to 97.8% through a 16-run architecture sweep, with 0.23 ms inference via ONNX",
        "Dockerised, CI-tested and deployed live on Vercel + Render"
      ]
    }
  ]
};

const techStack = {
  viewSkillBars: true,
  experience: [
    {
      Stack: "Frontend/Design",
      progressPercentage: "90%"
    },
    {
      Stack: "Backend",
      progressPercentage: "80%"
    },
    {
      Stack: "Programming",
      progressPercentage: "85%"
    },
    {
      Stack: "Tools",
      progressPercentage: "75%"
    },
    {
      Stack: "DevOps",
      progressPercentage: "65%"
    }
  ],
  displayCodersrank: false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer (Flutter)",
      company: "AmaliTech",
      companylogo: require("./assets/images/amalitech.png"),
      date: "Nov 2023 – Present",
      desc: "Building and shipping cross-platform Flutter apps for enterprise clients such as Deutsche Telekom.",
      descBullets: [
        "Build and ship ARMS, a cross-platform Flutter app, owning features end to end from Figma designs to App Store and Google Play releases",
        "Built the app's GraphQL data layer (typed queries and mutations, pagination, caching, error handling) behind a repository pattern",
        "Maintain and extend Deutsche Telekom mobile apps in a large distributed team without disrupting release cadence",
        "Raise code quality with unit, widget and integration tests, GitHub Actions CI and thorough code reviews"
      ]
    },
    {
      role: "Software Engineer Trainee (Flutter)",
      company: "AmaliTech",
      companylogo: require("./assets/images/amalitech.png"),
      date: "Apr 2023 – Oct 2023",
      desc: "Intensive 7-month Flutter engineering programme, from fundamentals to advanced architecture.",
      descBullets: [
        "Covered clean architecture, state management, testing, performance and CI/CD",
        "Built 6 Flutter apps, then moved straight onto client projects"
      ]
    },
    {
      role: "Full Stack Engineer",
      company: "ACR-Online Accounting Services",
      companylogo: require("./assets/images/acr_online.png"),
      date: "Jan 2023 – Apr 2023",
      desc: "Migrated the company website from WordPress to a custom Next.js, TypeScript and Node.js stack.",
      descBullets: [
        "Gave the business full control over performance, SEO and new features",
        "Built new features including an email subscription flow with a responsive Tailwind CSS UI"
      ]
    },
    {
      role: "Full Stack Engineer",
      company: "TechQuest Ltd",
      companylogo: require("./assets/images/techquest.png"),
      date: "Aug 2022 – Dec 2022",
      desc: "Built the company's first website from scratch on React, Node.js, Express and MongoDB.",
      descBullets: [
        "Shipped v1 end to end and set up the repository structure and Git workflow for later releases"
      ]
    },
    {
      role: "Full Stack Engineer Trainee",
      company: "Andela",
      companylogo: require("./assets/images/andela.png"),
      date: "Jan 2022 – Dec 2022",
      desc: "12-month software engineering programme: full-stack JavaScript (MERN), then React Native.",
      descBullets: [
        "Delivered team projects in agile squads with code review and CI, including Medica (telehealth) and Hoop (parking booking)"
      ]
    },
    {
      role: "Mobile Developer Trainee (Flutter)",
      company: "EnerPower Tech Solutions",
      companylogo: require("./assets/images/enerpower.jpeg"),
      date: "May 2021 – Nov 2021",
      desc: "Built Flutter screens and features from Figma mockups through to tested, working functionality.",
      descBullets: [
        "Developed core Dart and Flutter foundations (widgets, layouts, navigation, state management) and Git team workflows"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "false", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SELECTED PROJECTS THAT SHOW HOW I BUILD",
  projects: [
    {
      projectName: "SignLearn: Real-Time Sign Language Translator",
      projectDesc:
        "Final-year project. In-browser hand tracking streams landmarks over WebSockets to a TCN model (97.8% test accuracy, 0.23 ms ONNX inference) behind a Flask/Socket.IO API and Next.js frontend. Dockerised and deployed live.",
      footerLink: [
        {name: "Live Demo", url: "https://sign-learn-one.vercel.app"},
        {name: "Source", url: "https://github.com/911samuel/SignLearn"}
      ]
    },
    {
      projectName: "On-Device AI Image Classifier (Flutter)",
      projectDesc:
        "Fully offline inference with LiteRT via Dart FFI: ~20 ms on iPhone 13 Pro, ~2x faster on the Metal GPU, and a startup accuracy check that caught the Neural Engine returning wrong results. 100+ tests.",
      footerLink: [
        {name: "Source", url: "https://github.com/911samuel/on_device_ai"}
      ]
    },
    {
      projectName: "Medica: Telehealth App (React Native)",
      projectDesc:
        "Andela team project: doctor booking with video and chat consultations, payments, push notifications and biometric login, built with Expo, TypeScript, Redux Toolkit and Supabase.",
      footerLink: [
        {
          name: "Source",
          url: "https://github.com/atlp-rwanda/commanders-rn-medica"
        }
      ]
    },
    {
      projectName: "Posts Demo: Native Android (Kotlin, Jetpack Compose)",
      projectDesc:
        "News feed on clean architecture and MVVM: StateFlow UI state, Retrofit/Moshi data layer, pull-to-refresh and full loading, empty and error states.",
      footerLink: [
        {name: "Source", url: "https://github.com/911samuel/post-demo"}
      ]
    },
    {
      projectName: "Calendar App (Flutter, Riverpod, Firebase)",
      projectDesc:
        "Event scheduling with Firebase Auth and Firestore, FCM push and local notifications, onboarding and light/dark themes.",
      footerLink: [
        {name: "Source", url: "https://github.com/911samuel/calendar_app"}
      ]
    },
    {
      projectName: "Netpipo Employee API",
      projectDesc:
        "TypeScript/Express/MongoDB REST API with JWT authentication, role-based access, Swagger docs, unit tests and GitHub Actions CI.",
      footerLink: [
        {name: "Source", url: "https://github.com/911samuel/NetpipoBackend"}
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Introduction to Flutter Course",
      subtitle: "Issued by Simplilearn, May 2024",
      image: require("./assets/images/simplilearn.jpeg"),
      imageAlt: "Simplilearn Logo",
      footerLink: [
        {
          name: "View Certification",
          url: "https://www.simplilearn.com/free-flutter-foundation-course-skillup?utm_source=shared-certificate&utm_medium=shared-course&utm_campaign=shared-certificate-course-promotion"
        }
      ]
    },
    {
      title: "CODEXTREME 2024",
      subtitle: "Issued February 2024",
      image: require("./assets/images/codeextreme.png"),
      imageAlt: "CODEXTREME Logo",
      footerLink: [
        {
          name: "View Credential",
          url: "https://credsverse.com/credentials/3017baf0-d4a9-46d9-a4f8-cf0bb0028e7e"
        }
      ]
    },
    {
      title: "JavaScript Algorithms and Data Structures (Beta)",
      subtitle: "Issued by freeCodeCamp, December 2023",
      image: require("./assets/images/free_code_camp_logo.jpeg"),
      imageAlt: "freeCodeCamp Logo",
      footerLink: [
        {
          name: "View Credential",
          url: "https://www.freecodecamp.org/certification/samAbayizera/javascript-algorithms-and-data-structures-v8"
        }
      ]
    }
  ],
  display: true
};

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+250 784724228",
  email_address: "samuelabayizera@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "AbayizeraSam", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
